"use client"
import Fuse from "fuse.js";
import React, { useState, useEffect, useRef, useMemo } from "react";
import {
  Navbar,
  Input,
  Typography,
  IconButton,
  Menu,
  MenuItem,
  MenuList,
  Collapse,
  Badge,
} from "@material-tailwind/react";
import { RxCross2 } from "react-icons/rx";
import { PiShoppingCartSimpleBold } from "react-icons/pi";
import { HiMenuAlt1 } from "react-icons/hi";
import { GiShoppingCart } from "react-icons/gi";
import { usePathname, useRouter } from 'next/navigation';
import { FaRegCircleUser } from "react-icons/fa6";
import Link from "next/link";
import { IoSearch } from "react-icons/io5";
import Image from "next/image";
import { useDispatch, useSelector } from "react-redux";
import { ImCross } from "react-icons/im";
import { getCartItemStart, getCartItemSuccess } from "@/GlobalRedux/Slices/allCartItems";
import { getCartItem } from "@/API/response";
import { toggleDrawer } from "@/GlobalRedux/Slices/drawerCart";
import { getSessionId } from "@/utils/session";
export function Header() {
  const [inputValue, setInputValue] = useState("");
  const [openNav, setOpenNav] = React.useState(false);
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [showSearchModal, setShowSearchModal] = useState(false);
  const pathName = usePathname();
  const router = useRouter();
  const dispatch = useDispatch();
  const { allCartItem, isLoader } = useSelector((state) => state.cartItem)
  const { allProducts } = useSelector((state) => state.allproducts);
  const modalRef = useRef(null); // Reference for the modal container
  const closeMenu = () => setIsMenuOpen(false);
  const fuseOptions = {
    keys: ["name"],      // Search field
    threshold: 0.6,      // Matching strictness (0.0 = exact, 1.0 = loose)
    includeScore: true,  // Agar score chahiye toh true, nahi toh ignore kar sakte ho
  };
  const filteredProducts = useMemo(() => {
    if (!inputValue) return allProducts; // Agar search empty ho toh saare products
    const fuse = new Fuse(allProducts, fuseOptions);
    const result = fuse.search(inputValue);
    // console.log("Filtered products:", result);
    return result.map((item) => item.item);
  }, [inputValue, allProducts]);

// all cart items 
 const getCartProducts = async () => {
  const SessionId = getSessionId()
    // const getSessionId = localStorage.getItem("sessionId")
    try {
      dispatch(getCartItemStart())
      const response = await getCartItem("cart/getCart", SessionId);
      dispatch(getCartItemSuccess(response))
    } catch (error) {
      console.log(error)
    }
  }
  
  useEffect(()=>{
    getCartProducts()
  },[])
  const handleSearchChange = (e) => {
    setInputValue(e.target.value);
  };

  const handleSearchClick = () => {
    setShowSearchModal(true);
  };

  // Close modal when clicked outside
  const handleClickOutside = (event) => {
    if (modalRef.current && !modalRef.current.contains(event.target)) {
      setShowSearchModal(false);
    }
  };
const profileMenuItems = [
  {
    label: "My Profile",
    icon: FaRegCircleUser,
  },
  // {
  //   label: "Edit Profile",
  //   icon: FaRegEdit,
  // },
  // {
  //   label: "Sign Out",
  //   icon: BiLogOutCircle,
  // },
];

  useEffect(() => {
    if (showSearchModal) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [showSearchModal]);

  const handleResultClick = ( product) => {
    setShowSearchModal(false); // Close modal
    router.push(`/products/${product?.name?.replace(/\s+/g, "-")}-${product?._id}`); // Redirect to product page
  };
  // new close menu bar
    React.useEffect(() => {
      window.addEventListener(
        "resize",
        () => window.innerWidth >= 960 && setOpenNav(false),
      );
    }, []);
// navlist
    const navList = (
      <ul className="mb-4 mt-2 flex flex-col gap-2 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6 text-pureWhite">
        <Typography
          as="li"
          variant="small"
          // color="blue-gray"
          className="p-1 font-bold"
          onClick={()=>{setOpenNav(false)}}
        >
          <a href="/" className={`${pathName === '/' ? 'text-pureWhite italic fontbold translate-x-1' : ''} flex items-center`}>
            Home
          </a>
        </Typography>
        <Typography
          as="li"
          variant="small"
          // color="blue-gray"
          className="p-1 font-bold"
          onClick={()=>{setOpenNav(false)}}
        >
          <Link href="/products" className={`${pathName === '/products' ? 'text-pureWhite italic fontbold translate-x-1' : ''} flex items-center`}>
            Products
          </Link>
        </Typography>
       
        <Typography
          as="li"
          variant="small"
          // color="blue-gray"
          className="p-1 font-bold"
          onClick={()=>{setOpenNav(false)}}
        >
          <a href="/blogs" className={`${pathName === '/blogs' ? 'text-pureWhite italic fontbold translate-x-1' : ''} flex items-center`}>
          Blog
          </a>
        </Typography>
        <Typography
          as="li"
          variant="small"
          // color="blue-gray"
          className="p-1 font-bold"
          onClick={()=>{setOpenNav(false)}}
        >
          <a href="/contact" className={`${pathName === '/contact' ? 'text-pureWhite italic fontbold translate-x-1' : ''} flex items-center`}>
            Contact 
          </a>
        </Typography>
        <Typography
          as="li"
          variant="small"
          // color="blue-gray"
          className="p-1 font-bold"
          onClick={()=>{setOpenNav(false)}}
        >
          <a href="/about" className={`${pathName === '/about' ? 'text-pureWhite italic fontbold translate-x-1' : ''} flex items-center`}>
          About
          </a>
        </Typography>
        {/* <Typography
          as="li"
          variant="small"
          // color="blue-gray"
          className="p-1 font-bold"
          onClick={()=>{setOpenNav(false)}}
        >
          <a href="/login" className={`${pathName === '/login' ? 'text-pureWhite italic fontbold translate-x-1' : ''} flex items-center`}>
            Login 
          </a>
        </Typography> */}
        
      </ul>
    );
    
  return (
    // <main className="w-full h-full backdrop-blur-lg bg-opacity-40 sticky top-0 z-10">
    <main className="w-full h-full bg-darkBlack  sticky top-0 z-10">
      <div className="text-[#0b0b0b] hidden md:flex bg-white py-1  justify-center text-center font-semibold text-lg">
        <marquee scrollamount="15" scrolldelay="50">✨ Shop now & get up to 50% off storewide! ✨</marquee>
      </div>
      <div className="text-[#0b0b0b] bg-white md:hidden py-1 flex justify-center text-center font-semibold text-lg">
        <marquee >✨ Shop now & get up to 50% off storewide! ✨</marquee>
      </div>
  
      {/* <Navbar className="h-max max-w-6xl mx-auto bg-white/15 backdrop-blur-lg rounded-none border-none shadow-none px-2 py-2 lg:px-8 lg:py-2"> */}
      <Navbar className="h-max max-w-6xl mx-auto bg-darkBlack rounded-none border-none shadow-none px-2 py-2 lg:px-8 lg:py-2">
        <div className="flex items-center  justify-between text-darkBlack">
        <span className="">
            <a href="/" className="bg-gray-300">
              <Image
                height={800}
                width={700}
                src="/Images/new_logo.png"
                 alt="Mystical Fragrance - Luxury Perfume Brand Logo"
                className="h-24 w-full   object-contain"
              />
            </a>
          </span>
          <div className="mr-4 hidden lg:block">{navList}</div>
          <div className="flex items-center sm:gap-4">

          <span className="hidden lg:flex">
            <IoSearch
            size={30}
            onClick={handleSearchClick}
            className=" hover:cursor-pointer text-pureWhite"
            />
              {/* <Input
                placeholder="Search ...."
                name="inputSearch"
                value={inputValue}
                onChange={handleSearchChange}
                onClick={handleSearchClick}
                labelProps={{
                  className: "hidden",
                }} 
                className="!border !border-gray-300 bg-white text-gray-900 shadow-lg shadow-gray-900/5 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100 focus:!border-gray-900 focus:ring-gray-900/10"
              /> */}

            </span>
            {/* <a href={'/addCart'}> */}
            <span onClick={()=>{ dispatch(toggleDrawer())}} className=" cursor-pointer hidden lg:block ">
            <Badge 
             content={allCartItem?.items?.length}
              className={allCartItem?.items?.length == 0|| null? 'hidden':'flex items-center justify-center p-0'}>
              <PiShoppingCartSimpleBold size={30} className="text-pureWhite"/>
            </Badge>
            </span>
          {/* </a> */}
            {/* menu list  */}
             <Menu open={isMenuOpen} handler={setIsMenuOpen} placement="bottom-end"   >
                        {/* <MenuHandler >
                          <Button
                            variant="text"
                            color="blue-gray"
                            className="items-center rounded-full p-0 hidden lg:block "
                          >
                          <Avatar variant="circular" size="md" alt="No Profile" withBorder={true} color="blue-gray" className="rounded-full p-0.5" src="https://res.cloudinary.com/dsvbvqa5m/image/upload/v1735808592/noprofile_p83ojd.webp" />
                          </Button>
                        </MenuHandler> */}
                        <MenuList className="p-1 hidden lg:block">
                          {profileMenuItems.map(({ label, icon }, key) => {
                            const isLastItem = key === profileMenuItems.length - 1;
                            return (
                              <MenuItem
                                key={label}
                                onClick={closeMenu}
                                className={`flex items-center gap-2 rounded ${isLastItem
                                  ? "hover:bg-red-500/10 focus:bg-red-500/10 active:bg-red-500/10"
                                  : ""
                                  }`}
                              >
                                {React.createElement(icon, {
                                  className: `h-4 w-4 ${isLastItem ? "text-red-500" : ""}`,
                                  strokeWidth: 2,
                                })}
            
            
                                <Typography
                                  as="span"
                                  variant="small"
                                  className="myfont"
                                  color={isLastItem ? "red" : "inherit"}
                                >
                                    {label}
                                </Typography>
                              </MenuItem>
                            );
                          })}
                        </MenuList>
             </Menu>
            {/* menu list  */}
            </div>

          <div className="flex items-center lg:hidden">
             <Input
                placeholder="Search ...."
                name="inputSearch"
                value={inputValue}
                onChange={handleSearchChange}
                onClick={handleSearchClick}
                labelProps={{
                  className: "hidden",
                }} 
                className="!border !border-gray-300 bg-white text-gray-900 shadow-lg shadow-gray-900/5 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100 focus:!border-gray-900 focus:ring-gray-900/10"
              />
          <a href={'/addCart'}>
            <span className=" cursor-pointer px-2 sm:px-0 ">
            <Badge 
               content={allCartItem?.items?.length}
              className={allCartItem?.items?.length == 0|| null? 'hidden':'flex items-center justify-center p-0'}>
              <PiShoppingCartSimpleBold size={30}  className="text-pureWhite "/>
            </Badge>
            </span>
          </a>
            <IconButton variant="text" className="sm:flex  hidden lg:hidden p-0 m-0" onClick={() => setOpenNav(!openNav)}>
              {openNav ? <RxCross2 className="h-6 w-6 text-gray-100" /> : <HiMenuAlt1 className="h-6 w-6 text-gray-100" />}
            </IconButton>
          </div>
        </div>
        <Collapse open={openNav}>
        {navList}
      </Collapse>
      </Navbar>

      {/* Full-screen modal for search */}
      {showSearchModal && (
        <div 
          ref={modalRef}
          // className="fixed inset-0 bg-black bg-opacity-50 z-50 min-h-screen w-screen top-0 flex items-center justify-center"
          className="fixed inset-0 bg-black bg-opacity-50 z-50 min-h-screen w-screen top-0 flex  justify-center"
        >
          <div className="bg-white shadow-lg rounded-lg w-11/12 max-w-lg max-h-[70vh] top-8 min-h-[70vh] overflow-auto p-4 relative">
            <button
              onClick={() =>{ 
                setShowSearchModal(false) 
                setInputValue("")
              }}
              className="absolute py-2  top-2 right-2 text-gray-800 hover:text-gray-600"
            >
              <ImCross size={25}/>
            </button>

            {/* Search Input - Fixed at the top of the modal */}
            <div className="absolute top-12 left-4 right-4 ">
              <Input
                placeholder="Search ...."
                name="inputSearch"
                value={inputValue}
                onChange={handleSearchChange}
                labelProps={{
                  className: "hidden",
                }} 
                className="!border  !border-gray-300 bg-white text-gray-900 shadow-lg shadow-gray-900/5 ring-4 ring-transparent placeholder:text-gray-500 placeholder:opacity-100  focus:ring-gray-900/10  "
              />
            </div>

            <div className="h-full mt-20 overflow-y-auto ">
               {filteredProducts && filteredProducts.length > 0 ? (
                filteredProducts.map((product) => (
                  <div 
                    key={product?._id}
                    onClick={() => handleResultClick(product)}
                    className="flex px-2 py-2 text-darkBlack gap-3 items-center bg-gray-100 hover:bg-gray-200 cursor-pointer"
                  >
                    <span className="flex-shrink-0 overflow-hidden rounded">
                      <img src={product.images[0]} alt={product?._id} className="h-10 w-10 object-contain"/>
                    </span>
                    <span>{product?.name}</span>
                  </div>
                ))
              ) : (
                <div className="px-4 py-2 flex flex-col items-center text-gray-500 w-full text-center">
                  <span className="px-4 py-2 text-gray-500 w-full text-center">No results found</span>
                  <span>
                    <img src="/Images/no-results.png" className="h-20 w-20 object-contain" alt="No results"/>
                  </span>
                </div>
              )}
            </div>
          </div>
        </div>
      )}

    </main>
  );
}
